let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3fuR9"), load("2bqSD"), load("gZU54"), load("e8jpx"), load("bGhLc"), load("iRKhU")]).then(() => parcelRequire('UK5pP'));